import { read } from "hooks/useSession.ts";
import {
	MARKETING_MATERIALS_PAGE_KEY,
	MARKETING_MATERIALS_SEARCH_KEY
} from "features/MarketingMaterials/pages/marketingMaterialsConstants.ts";

export const getMarketingMaterialsLandingUrl = (termOverride?: string, pageOverride?: number) => {
	const term = (termOverride ?? read(MARKETING_MATERIALS_SEARCH_KEY) ?? "").trim();
	const page = Number(pageOverride ?? read(MARKETING_MATERIALS_PAGE_KEY) ?? 1);

	const searchParams = new URLSearchParams();

	if (term) searchParams.set("term", term);
	if (Number.isInteger(page) && page > 1) searchParams.set("page", String(page));

	const search = searchParams.toString();
	return search ? `/marketing-materials?${search}` : "/marketing-materials";
};
